/**
 * Text Alignment Class enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum TEXT_ALIGN_CLASS {
	LEFT = "text--align-left",
	CENTER = "text--align-center",
	RIGHT = "text--align-right",
	BLOCK = "text--align-block",
	DEFAULT = "text--align-default"
}

export type TEXT_ALIGN_CLASS_string = keyof typeof TEXT_ALIGN_CLASS;
